/**
 * All customer-facing UI strings, currently Norwegian only.
 * Keep this the single source of truth so it's easy to add more languages later.
 */
export const t = {
  // Header / nav
  nav: {
    shop: "Butikk",
    editorial: "Editorial",
    lookbook: "Lookbook",
    wishlist: "Ønskeliste",
    account: "Konto",
    search: "Søk",
    bag: "Handlekurv",
  },
  // Common
  common: {
    soldOut: "Utsolgt",
    inStock: "På lager",
    from: "fra",
    close: "Lukk",
    freeShipping: "Rask levering · 3–7 virkedager",
    handmade: "Håndlaget",
    smallBatch: "Små serier",
    norwegianDesign: "Norsk design",
    globalDelivery: "Global levering",
  },
  home: {
    eyebrow: "Nye kolleksjon",
    heroTitle: "MARCINI",
    heroCta: "Oppdag kolleksjonen",
    heroSecondary: "Se lookbook",
    newDrop: "Nye Produkter",
    newDropSubtitle: "Sist inn i Atelieret",
    newDropCta: "Se alle nye produkter",
    curated: "Kuratert",
    enterByChapter: "Utforsk kolleksjoner",
    editorialEyebrow: "Editorial · Kapittel 01",
    editorialTitle: "Design som tar plass — uten å rope.",
    editorialBody:
      "Utvalgte materialer, oversized silhuetter og en varsom detaljistrikk gjør hvert plagg til noe du bruker i mange år.",
    editorialCta: "Se mer",
    lookbookTitle: "Lookbook",
    lookbookViewAll: "Se alle →",
    featuredViewAll: "Se alle produkter →",
    pieces: "produkter",
  },
  shop: {
    eyebrow: "Butikken",
    title: "Alle produkter",
    searchPlaceholder: "Søk",
    inStockOnly: "På lager",
    sort: {
      featured: "Sorter · Utvalgte",
      priceAsc: "Pris · Lav til høy",
      priceDesc: "Pris · Høy til lav",
      title: "A – Å",
    },
    empty: "Ingen produkter passer søket.",
  },
  pdp: {
    size: "Velg størrelse",
    sizeGuide: "Størrelsesguide",
    addToBag: "Legg i handlekurven",
    savedToWishlist: "Lagret i ønskelisten",
    saveToWishlist: "Lagre i ønskelisten",
    notify: "Varsle meg når tilgjengelig",
    notifyPlaceholder: "din@epost.no",
    notifySubmit: "Varsle meg",
    color: "Farge",
    colorCount: "farger",
    material: "Materiale",
    care: "Vaskeanvisning",
    shipping: "Frakt",
    shippingBody: "Rask levering — 3–7 virkedager i Norge.",
    returns: "Retur",
    returnsBody: "14 dagers angrerett.",
    completeTheLookEyebrow: "Fullfør stilen",
    completeTheLookTitle: "Kombiner med",
    bundleEyebrow: "Bundle & spar",
    bundleTitle: "Kombiner og spar 10 %",
    bundleAddBoth: "Legg begge i handlekurven",
    bundleNote: "10 % rabatt beregnes automatisk i kassen når begge er i handlekurven.",
    bundleSelectSize: "Velg størrelse først",
    stickyBuyNow: "Legg i handlekurven",
    stickyPickSize: "Velg størrelse",
    sizeGuideTitle: "Størrelsesguide",
    sizeGuideModelsLabel: "Modellene",
    sizeGuideFitLabel: "Passform",
    sizeGuideFitBody:
      "Marcini-plaggene er kuttet med et oversized, avslappet snitt. Vår erfaring: hvis du brukte L sist, velg M nå.",
    sizeGuideHelpLabel: "Trenger du hjelp?",
    sizeGuideHelpBody:
      "Send oss en melding på Instagram @marcini eller til hei@marcini.no — vi svarer samme dag.",
  },
  cart: {
    title: "Handlekurv",
    empty: "Handlekurven din er tom",
    emptyBody: "Sett sammen ditt utvalg, plagg for plagg.",
    size: "Str.",
    subtotal: "Delsum",
    disclaimer: "Frakt og avgifter beregnes i kassen.",
    checkout: "Gå til kassen",
    checkoutLoading: "Laster kassen…",
  },
  wishlist: {
    eyebrow: "Ditt utvalg",
    title: "Ønskelisten din",
    empty: "Ingenting lagret — enda.",
    emptyCta: "Begynn å utforske →",
  },
  account: {
    eyebrow: "Kunde",
    title: "Konto",
    intro:
      "Logg inn via Shopify for å se ordrehistorikk, favoritter og få tidlig tilgang til nye slipp.",
    signIn: "Logg inn med Shopify",
    signInHint: "Personlig data lagres aldri i cache.",
    session: "Økt",
    market: "Marked",
    marketValue: "Norge · NOK",
  },
  lookbook: {
    eyebrow: "Editorial · Marcini",
    title: "Lookbook",
    intro:
      "Utvalgte bilder og kapitler fra vårt eget atelier. Klikk på et bilde for å utforske plaggene.",
    shopLook: "Se plagget →",
  },
  footer: {
    newsletterEyebrow: "Nyhetsbrev",
    newsletterTitle: "Bli med i Marcini-listen.",
    newsletterBody:
      "Vær først ute med nye slipp, kampanjer og innsyn fra atelieret.",
    newsletterPlaceholder: "din@epost.no",
    newsletterConsent:
      "Jeg samtykker til å motta e-post fra Marcini. Kan meldes av når som helst.",
    welcomeToast: "Velkommen til Marcini-listen.",
    genericError: "Noe gikk galt",
    col1: "Butikk",
    col2: "Univers",
    col3: "Kundeservice",
    tagline: "Marcini · Oslo · Est. 2024",
    tech: "Headless commerce · Powered by Shopify",
  },
  toasts: {
    added: "Lagt i handlekurven",
    bundleAdded: "Bundle lagt i handlekurven",
    savedWishlist: "Lagret i ønskelisten",
    removedWishlist: "Fjernet fra ønskelisten",
    addFail: "Kunne ikke legge til",
    bisSuccess: "Vi varsler deg når varen er tilbake på lager.",
    bisFail: "Kunne ikke abonnere",
    checkoutRedirect: "Sender deg til kassen …",
    checkoutFail: "Kunne ikke starte kassen",
  },
};
